"use client";

/**
 * NewForm DS hover icon — a paperclip for "attach files".
 * On hover the clip tilts back and lifts, as if being unhooked.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function AttachIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="g a-clip">
        <path d="M20.4 11.6 12 20a5.4 5.4 0 0 1-7.6-7.6l8.4-8.4a3.6 3.6 0 0 1 5.1 5.1l-8.4 8.4a1.8 1.8 0 0 1-2.6-2.6l7.8-7.7" />
      </g>
    </HoverIconSvg>
  );
}
